import React from 'react';
import {Alert} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

// Historical data may predate the NVR-side redactor. Never render raw URLs.
export const safeFailureDetail = value => String(value || '')
  .replace(/\b(?:https?|rtsps?|rtmps?):\/\/[^\s;,]+/gi, '[URL omesso]')
  .replace(/\b(password|passwd|token|authorization|api[_-]?key)\s*[:=]\s*[^\s;,]+/gi, '$1=[omesso]')
  .slice(0, 512);

export default function NvrExecutionFailure({failure, timestamp}) {
  const {t} = useTranslation();
  const error = failure && failure.error;
  if (!error || typeof error !== 'object' || typeof error.code !== 'string') {
    return null;
  }
  const date = Date.parse(timestamp);
  return <Alert variant="warning" role="status" className="mt-3">
    <strong>{t('NVR_LAST_EXECUTION_ERROR', 'Ultimo errore di elaborazione')}</strong>
    {' — '}<code>{error.code}</code>
    <p className="mb-1">{safeFailureDetail(error.detail)}</p>
    <small>
      {t('NVR_ERROR_HISTORICAL', 'Segnalazione storica, non necessariamente un guasto attuale.')}
      {Number.isFinite(date) ? ` ${new Date(date).toLocaleString()}.` : ''}
      {failure.slotId ? ` Evento ${failure.slotId}.` : ''}
      {Array.isArray(error.cameraIds) ? ` Camere: ${error.cameraIds.join(', ')}.` : ''}
      {error.phase ? ` Fase: ${error.phase}.` : ''}
      {' '}{error.retryable
        ? t('NVR_ERROR_RETRY_ELIGIBLE', 'Ritentabile se restano tempo e tentativi disponibili; non indica un retry già pianificato.')
        : t('NVR_ERROR_NO_RETRY', 'Nessuna ripetizione automatica di questa elaborazione.')}
    </small>
  </Alert>;
}
